<template>
    <div id="profile" class="profile">
        <div class="container">
            <h2>Личный кабинет</h2>
            <div class="profile-navbar">
                <div class="profile-navbar-switcher">
                    <div @click="switchTo('ecp')" :class="{ 'profile-navbar-switcher-button-active': switcher.ecp, 'profile-navbar-switcher-button': true }">Выписки ЕГРЮЛ ЭЦП</div>
                    <div @click="switchTo('history')" :class="{ 'profile-navbar-switcher-button-active': switcher.history, 'profile-navbar-switcher-button': true }">История</div>
                    <div v-if="switcher.history && false" class="profile-navbar-switcher-button-submenu">
                        <div>Вся история</div>
                        <div>Формировка списка</div>
                        <div>Карточки компании</div>
                    </div>
                    <div @click="switchTo('egrn')" :class="{ 'profile-navbar-switcher-button-active': switcher.egrn, 'profile-navbar-switcher-button': true }">Выписки ЕГРН</div>
                </div>
                <div v-if="user" class="profile-navbar-profile">
                    <div class="profile-navbar-profile-icon"></div>
                    <div class="profile-navbar-profile-info">
                        <div v-if="user.user_data" class="profile-navbar-profile-info-name">{{user.user_data.user_name}}</div>
                        <div v-if="user.user_data" class="profile-navbar-profile-info-email">{{user.user_data.user_email}}</div>
                        <div @click="showEditProfileModal = !showEditProfileModal" class="profile-navbar-profile-info-edit">Редактировать</div>
                    </div>
                </div>
                <div v-if="user" class="profile-navbar-status">
                    <div>Статус подписки: 
                        <span v-if="userSubscribeStatus" style="color: #83CA8B; font-weight: 600;">активна</span>
                        <span v-else style="color: #ca6868; font-weight: 600;">не активна</span>
                    </div>
                    <div>от <span>{{userSubscribtionFrom}}</span> до <span>{{userSubscribtionTo}}</span></div>
                </div>
            </div>
            <div v-if="switcher.ecp" class="profile-content profile-content__ecp">
                <div class="profile-content-menu"></div>
                <table class="profile-content-table">
                    <thead class="profile-content-table-header">
                        <tr>
                            <th>Дата</th>
                            <th class="profile-content-table-body-item-title">Название</th>
                            <th>Скачать</th>
                        </tr>
                    </thead>
                    <tbody class="profile-content-table-body">
                        <tr class="profile-content-table-body-item" v-for="(e,i) in ECP" :key="i">
                            <td class="profile-content-table-body-item-date">{{e.date.split('-').reverse().join('.')}}</td>
                            <td class="profile-content-table-body-item-title">
                                <a v-if="e.ogrn" :href="`/company/${e.ogrn}`">{{e.short_name}}</a>
                                <span v-else>{{e.short_name}}</span>
                                <tooltip style="margin-left: 5px" v-if="e.ogrn" :ogrn="e.ogrn"></tooltip>
                            </td>
                            <td class="profile-content-table-body-item-status">
                                <a v-if="e.id_file" :href="`${downloadURL + e.id_file}?sid=${apiSession}`">
                                    <i class="lnr lnr-download"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="switcher.history" class="profile-content profile-content__history">
                <adminFilters v-if="admin" adminType="check_ul" :onFilterCallback="getCombinedHistory" searchPlaceholder="Поиск по ОГРН" @admin-request="adminRequest" />
                <div v-if="history.pagination && history.items.length" class="profile-content-menu">
                    <dropDownButton title="Скачать в .xlsx" :items="['Первые 5000 записей', 'Текущую страницу']" :onSelect="downloadXLSX" :loading="downloadLoading" />
                    <pagination :pagination="history.pagination" :onTurnPageCallBack="getCombinedHistory" :showRowsPerPageSelection="true"/>
                    <!-- <button class="profile-xlsx__button" @click="downloadXLSX" style="margin: 10px 0px">Скачать в .xlsx</button> -->
                </div>
                <template v-if="history.loading">
                    <shestirenkaLoader/>
                </template>
                <template v-else>
                    <table class="profile-content-table">
                        <thead>
                            <tr>
                                <th>Дата</th>
                                <th>Время</th>
                                <th v-if="admin">Пользователь</th>
                                <th>Запрос</th>
                                <th>ОГРН</th>
                                <th>Комплексный Отчет</th>
                                <th>ПДО</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="profile-content-table-body-item" v-for="(e,i) in history.items" :key="i">
                                <td>{{new Date(e.date).toLocaleDateString()}}</td>
                                <td>{{getHoursAndMinutesFomDateObjectString(e.date)}}</td>
                                <td v-if="admin">
                                    <span v-if="e.user_name || e.user_login">{{e.user_name}} {{e.user_login ? `(${e.user_login})` : "" }}</span>
                                    <span v-else>—</span>
                                </td>
                                <td class="profile-content-table-body-item-title">
                                    <a v-if="e.ogrn" :href="`/company/${e.ogrn}`" target="_blank">{{e.title ? e.title : e.ogrn}}</a>
                                    <span v-else>{{e.ogrn}}</span>
                                    <tooltip v-if="e.ogrn" :ogrn="e.ogrn"></tooltip>
                                </td>
                                <td>{{e.ogrn ? e.ogrn : "—"}}</td>
                                <td style="text-align: center">
                                    <a v-if="e.ko_file" target="_blank" :href="`${downloadURL + e.ko_file}?sid=${apiSession}`">
                                        <i class="lnr lnr-download" style="font-size: 20px"></i>
                                    </a>
                                    <span v-else>—</span>
                                </td>
                                <td style="text-align: center">
                                    <a v-if="e.pdo_file" target="_blank" :href="`${downloadURL + e.pdo_file}?sid=${apiSession}`">
                                        <i class="lnr lnr-download" style="font-size: 20px"></i>
                                    </a>
                                    <span v-else>—</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <div v-if="history.pagination && history.items.length" class="profile-content-menu">
                    <pagination :pagination="history.pagination" :onTurnPageCallBack="getCombinedHistory" :showRowsPerPageSelection="true"/>
                </div>
            </div>
            <div v-if="switcher.egrn" class="profile-content profile-content__egrn">
                <div v-if="EGRNPagination" class="profile-content-menu">
                    <pagination :pagination="EGRNPagination" :onTurnPageCallBack="getEGRN" :showRowsPerPageSelection="true" />
                </div>
                <egrnTable :data="EGRN" />
                <div v-if="EGRNPagination" class="profile-content-menu">
                    <pagination :pagination="EGRNPagination" :onTurnPageCallBack="getEGRN" :showRowsPerPageSelection="true" />
                </div>
            </div>
        </div>
        <div @click="triggerEditProfileModal" class="edit-profile-modal-overflow" v-if="showEditProfileModal">
            <div class="edit-profile-modal-window">
                <i class="lnr lnr-cross" @click="triggerEditProfileModal"></i>
                <div class="edit-profile-modal-window-header">Профиль</div>
                <div v-if="user" class="edit-profile-modal-window-status">
                    <div class="edit-profile-modal-window-status-block">
                        <span class="lnr lnr-checkmark-circle"></span>
                        <div class="edit-profile-modal-window-status-block-text">
                            Статус подписки: <br>
                            <span v-if="userSubscribeStatus" style="color: #83CA8B; font-weight: 600;">Активна</span>
                            <span v-else style="color: #ca6868; font-weight: 600;">Не активна</span>
                        </div>
                    </div>
                    <div class="edit-profile-modal-window-status-block">
                        <span>Подписка действует:</span>
                        <br>
                        <span style="font-weight: 500">{{userSubscribtionFrom}} - {{userSubscribtionTo}}</span>
                    </div>
                </div>
                <form @submit.prevent="submitForm" ref="edit-profile-form" class="edit-profile-modal-window-form" method="POST" action="/edit_profile">
                    <div class="edit-profile-modal-window-form-block">
                        <div class="edit-profile-modal-window-form-group">
                            <div class="edit-profile-modal-window-form-group-header">Название компании*</div>
                            <div class="edit-profile-modal-window-form-group-input">
                                <input type="text" name="profile_name" ref="profile_name" :value="user.user_data.user_name" required>
                            </div>
                        </div>
                        <div class="edit-profile-modal-window-form-group">
                            <div class="edit-profile-modal-window-form-group-header">ФИО пользователя*</div>
                            <div class="edit-profile-modal-window-form-group-input">
                                <input type="text" name="profile_fio" ref="profile_fio" :value="user.user_data.user_contact_name" required>
                            </div>
                        </div>
                        <div class="edit-profile-modal-window-form-group">
                            <div class="edit-profile-modal-window-form-group-header">Контактный e-mail*</div>
                            <div class="edit-profile-modal-window-form-group-input">
                                <input type="text" name="profile_email" ref="profile_email" :value="user.user_data.user_email" required>
                            </div>
                        </div>
                    </div>
                    <div class="edit-profile-modal-window-form-block">
                        <div class="edit-profile-modal-window-form-group">
                            <div class="edit-profile-modal-window-form-group-header">ИНН компании*</div>
                            <div class="edit-profile-modal-window-form-group-input">
                                <input type="text" name="profile_inn" ref="profile_inn" :value="user.user_data.user_bank_inn" required>
                            </div>
                        </div>
                        <div class="edit-profile-modal-window-form-group">
                            <div class="edit-profile-modal-window-form-group-header">Контактный телефон</div>
                            <div class="edit-profile-modal-window-form-group-input">
                                <input type="text" name="profile_phone" ref="profile_phone" :value="user.user_data.user_phone">
                            </div>
                        </div>
                    </div>
                    <div class="edit-profile-modal-window-footer">
                        <button type="submit">Сохранить</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { getQueryStringValue, downloadBinaryFile } from '@/helpers'
import tooltip from '@/components/ui/tooltip'
import shestirenkaLoader from '@/components/ui/shestirenkaLoader.vue'
import pagination from '@/components/ui/pagination.vue'
import dropDownButton from '@/components/ui/dropDownButton.vue'
import adminFilters from '@/components/ui/adminFilters.vue'
import egrnTable from '@/components/profile/egrnTable.vue'

export default {
    components: {
        egrnTable,
        tooltip,
        pagination,
        adminFilters,
        shestirenkaLoader,
        dropDownButton
    },
    data(){
        return {
            downloadLoading: false,
            showEditProfileModal: false,
            switcher: {
                history: true,
                ecp: false,
                egrn: false
            },
            ECP: [],
            EGRN: [],
            EGRNPagination: null,
            history: {
                items: [],
                pdf: null,
                pagination: null,
                loading: false,
                users: [],
                searchQuery: '',
                date_from: '',
                date_to: ''
            },
            checkbox: true
        }
    },
    mounted(){
        this.$store.dispatch("getUserInfo")
        this.getCombinedHistory()
        this.getECP()
        this.getEGRN()
        switch(getQueryStringValue("edited")){
            case 'success': UIkit.notify("Данные профиля успешно отправлены на изменение", {pos: 'top-center', status: 'success', timeout: 5000});break;
            case 'error': UIkit.notify("При отправке данных произошла ошибка. Повторите попытку позже или обратитесь в службу технической поддержки.", {pos: 'top-center', status: 'danger', timeout: 5000});break;
        }
    },
    methods: {
        finishDownload() { this.downloadLoading = false },
        downloadXLSX(item){
            const downloadFileInsideThenFn = res => {
                if(res.headers["content-type"] === "application/octet-stream") {
                    downloadBinaryFile(res.data, `История запросов ${new Date().toLocaleDateString()}`, 'xlsx')
                }
                this.downloadLoading = false
            }

            let limit, offset

            this.downloadLoading = true

            if(item == 'Первые 5000 записей') {
                limit = 5000
                offset = 0
            } else if(item == 'Текущую страницу') {
                limit = this.history.pagination.rows_per_page
                offset = limit * (this.history.pagination.current_page - 1)
            }

            this.$store.dispatch("RomAPI", {
                method: "user_history",
                responseType: 'arraybuffer',
                out_format: "xlsx",
                data: {
                    ogrn: parseInt(this.history.searchQuery.replace(/[^0-9]/g, '')),
                    users: this.history.users,
                    date_from: this.history.date_from,
                    date_to: this.history.date_to,
                    show_adm: this.checkbox,
                    offset,
                    limit
                }
            }).then(downloadFileInsideThenFn).finally(this.finishDownload)
        },
        adminRequest(value){
            this.checkbox = value
            console.log(this.checkbox)
        },
        submitForm(){
            this.$refs['edit-profile-form'].submit()
        },
        triggerEditProfileModal(e) {
            if(e.target == e.currentTarget) {
                this.showEditProfileModal = !this.showEditProfileModal
            }
        },
        switchTo(param){
            Object.keys(this.switcher).map(e => {
                this.switcher[e] = false
            })
            this.switcher[param] = true
        },
        getECP(){
            this.$store.dispatch("RomAPI", {
                method: "egrul_ecp",
                data: {
                    action: "listEgrulUser",
                    login: window.apiUser
                }
            }).then(e => {
                if(e.data.data && e.data.data.list_egrul && e.data.data.list_egrul.length){
                    this.ECP = e.data.data.list_egrul
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getEGRN(){
            this.$store.dispatch("RomAPI", {
                method: "egrn",
                data: { action: "list_egrn" }
            }).then(e => {
                if(e.data.data) {
                    this.EGRN = e.data.data.list_egrn
                    this.EGRNPagination = e.data.data.pagination
                }
            }).catch(err => {
                console.log(err)
            })
        },
        getCombinedHistory(
            offset = 0,
            limit = 50,
            searchQuery = this.history.searchQuery,
            users = this.history.users,
            date_from = this.history.date_from,
            date_to = this.history.date_to
        ) {
            this.history = {
                ...this.history,
                loading: true,
                searchQuery,
                users,
                date_from,
                date_to
            }

            this.$store.dispatch("RomAPI", {
                method: "user_history",
                data: {
                    ogrn: parseInt(searchQuery.replace(/[^0-9]/g, '')),
                    users,
                    date_from,
                    date_to,
                    show_adm: this.checkbox, 
                    offset,
                    limit
                }
            }).then(e => {
                console.log(e)
                if(e && e.data.data && e.data.data.history && e.data.data.history.length) {
                    this.history.items = e.data.data.history
                    this.history.pagination = e.data.data.pagination
                } else if(e.data.data.history == null){
                    this.history.items = []
                    this.history.pagintaion = {}
                }
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                this.history.loading = false
            })
        }
    },
    computed: {
        admin() {
            return this.$store.state.user.groups.filter(e => e.rules.adm_check_ul).length
        },
        userSubscribtionFrom() {
            if(this.$store.state.user.subscribes){
                return new Date(this.$store.state.user.subscribes[0].subscription_start_date * 1000).toLocaleDateString()
            } else {
                return null
            }
        },
        userSubscribtionTo() {
            if(this.$store.state.user.subscribes){
                return new Date(this.$store.state.user.subscribes[0].subscription_end_date * 1000).toLocaleDateString()
            } else {
                return null
            }
        },
        userSubscribeStatus() {
            if(this.$store.state.user.subscribes){
                return this.$store.state.user.subscribes[0].status
            } else {
                return null
            }
        },
        user() { return this.$store.state.user },
        apiSession() { return this.$store.state.user.apiSession },
        downloadURL() { return this.$store.state.v3?.downloadURL } 
    }
}
</script>

<style lang="sass" scoped>
@import "styles/global-variables"

$button-height: 32px

.profile
    padding: 50px 0
    font-family: Gotham Pro, sans-serif
    @include page()
    a
        border: 0
    h2
        font-size: 44px
        font-weight: 800
        @media screen and (max-width: $desktop-resolution)
            font-size: 32px
    &-navbar, &-content
        display: inline-block
        margin-top: 20px
        font-size: 16px
        vertical-align: top
    &-navbar
        @media screen and (max-width: $desktop-resolution)
            margin: 20px auto
            display: block
        width: 220px
        &-profile
            width: 100%
            margin-top: 30px
            &-icon
                width: 40px
                height: 50px
                background-image: url("/images/profile-pic.png")
            &-info
                padding-left: 10px
                max-width: 175px
                &-name
                    font-weight: bold
                &-email
                    font-weight: 400
                    font-size: 12px
                    color: #777
                &-edit
                    color: $link-blue-color
                    font-size: 13px
                    margin-top: 2px
                    cursor: pointer
                    &:hover
                        text-decoration: underline
            &-icon, &-info
                vertical-align: middle
                display: inline-block
        &-switcher
            &-button
                cursor: pointer
                width: 100%
                height: $button-height
                line-height: $button-height
                text-align: left
                padding: 0 15px
                border-radius: 3px
                margin: 5px 0
                font-weight: 500
                &:not(&-disabled)
                    &:hover
                        background-color: $hover-button-gray-color
                        color: $dark-text-color
                &-disabled
                    color: $disabled-button-color
                    cursor: default
                &-active
                    background-color: $active-button-bgc
                    color: $light-text-color
                    &:hover
                        background-color: lighten($active-button-bgc, 20%) !important
                &-submenu
                    padding-left: 30px
                    div
                        font-size: 14px
        &-status
            font-size: 14px
            font-weight: 400
            margin-top: 30px
            .lnr.lnr-sync
                color: gray
    &-content
        font-size: 14px
        width: calc(80% - 50px)
        margin-left: 50px
        margin-bottom: 50px
        @media screen and (max-width: 1280px)
            width: 780px
            margin-left: 10px
        @media screen and (max-width: 1024px)
            width: 720px
            margin-left: 0
        &-table, &-menu
            tr
                th
                    padding-bottom: 15px
                    font-size: 14px
                    font-weight: 500
                    text-align: left
                th, td
                    padding: 5px 15px
                    &:first-child
                        padding-left: 0
                td
                    font-weight: 400
            &-header
                text-align: left
                font-weight: 500
            &-body
                &-item
                    font-size: 12px
                    div
                        display: inline-block
                    &-selectButton
                        color: #A2B8FF
                    &-title
                        font-weight: 500 !important
                        width: 100%
                        font-size: 14px
                        &:not(th)
                            color: $link-blue-color
                    &-status
                        text-align: center
                        font-size: 18px
                        color: $link-blue-color
                    &-date
                        font-weight: 400
        &__history
        &__ecp
        &__history-pdf
    .profile-egrn-status-legend
        cursor: pointer
        color: #5F83F4
        padding-left: 30px
    .profile-xlsx
        @include form-group()

.edit-profile-modal
    font-family: Gotham Pro, Courier New, Courier, monospace
    &-overflow
        width: 100%
        height: 100vh
        background-color: rgba(black, .2)
        position: fixed
        top: 0
        left: 0
    &-window
        width: 700px
        margin: 50px auto
        background-color: #fff
        padding: 25px
        border-radius: 5px
        position: relative
        .lnr.lnr-cross
            position: absolute
            top: 25px
            right: 25px
            font-size: 20px
            cursor: pointer
        &-header
            font-size: 16px
            font-weight: 500
        &-status
            background-color: #ECECEC
            font-size: 0
            padding: 10px 20px
            border-radius: 7px
            margin: 20px auto 5px
            &-block
                font-size: 14px
                width: 50%
                display: inline-block
                vertical-align: top
                &-text
                    font-weight: 400
                    display: inline-block
                    vertical-align: top
                .lnr.lnr-checkmark-circle, .lnr.lnr-cross-circle
                    display: inline-block
                    vertical-align: top
                    font-size: 38px
                    margin-right: 10px
                    font-weight: 600
                .lnr.lnr-checkmark-circle
                    color: $active-green-color
                .lnr.lnr-cross-circle
                    color: $inactive-red-color
        &-form
            font-size: 0
            &-block
                display: inline-block
                vertical-align: top
                width: 50%
                font-size: 14px
            &-group
                width: 80%
                margin-top: 15px
                &-header
                    margin: 2px auto
                    font-weight: 400
                input
                    width: 100%
                    border-radius: 3px
                    padding: 4px 8px
                    border: 1px solid #B8B8B8
        &-footer
            text-align: right
            button
                width: 112px
                height: 34px
                text-align: center
                line-height: 34px
                color: #fff
                font-weight: 500
                font-size: 14px
                background-color: #4771F3
                border: 0
                border-radius: 5px
                cursor: pointer

@media screen and (max-width: $desktop-resolution)
    .profile,
    .profile-content
        width: 100%
    .profile-navbar
        margin: 20px 0
    .profile-content-table
        display: block
        width: 100%
        thead, th
            display: none
        tbody, tr
            display: block
            margin: 10px auto !important
            width: 100%
        td
            display: inline-block
            padding: 0 !important
            &:nth-child(1),
            &:nth-child(2),
            &:nth-child(4),
            &:nth-child(5),
            &:nth-child(6)
                display: none
        .profile-content-table-body-item-title
            width: auto
    .edit-profile-modal
        width: 100%
        &-overflow
            width: 100%
        &-window
            width: 95%
            padding: 25px 15px
            .lnr.lnr-cross
                right: 15px

@media screen and (max-width: $mobile-resolution)
    .profile-egrn-status-legend
        padding-left: 0 !important

    .edit-profile-modal-window
        &-status-block,
        &-form-block,
        &-form-group
            display: block
            width: 100%
            margin-top: 5px
        &-footer
            text-align: left
            margin-top: 10px
</style>